/**
 * FERP Portal - Search Entities GraphQL Query
 *
 * Cross-subgraph entity search query. Returns results from all enabled
 * subgraphs (FHIR, Payroll, ERP, Core) with subgraph context for rendering.
 *
 * FERP Principles:
 * - Data-driven: Backend controls which entities are searchable
 * - Repository pattern: Server-side search via repositories
 * - Tenant isolation: JWT claims enforce tenant boundary
 * - Dumb frontend: Only displays what backend returns
 */

import { gql } from '@apollo/client';

export const SEARCH_ENTITIES = gql`
  query SearchEntities($input: SearchEntitiesInput!) {
    searchEntities(input: $input) {
      items {
        id
        displayValue
        entityType
        subgraphId
        identifiers
        isLifeCritical
        icon
        detailPath
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
